import { render } from "./ComboDiscountGroupsManagement.html?vue&type=template&id=cb5365c8&scoped=true"
import script from "./ComboDiscountGroupsManagement.js?vue&type=script&lang=js"
export * from "./ComboDiscountGroupsManagement.js?vue&type=script&lang=js"

import "./ComboDiscountGroupsManagement.css?vue&type=style&index=0&id=cb5365c8&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5365c8"]])

export default __exports__